// TODO: redesign-dticket - make it reusable across Subscription Pause flow

import { useTranslation } from 'react-i18next';

import { ErrorAnim, MplButton, MplModal } from '@mopla/ui';

interface IDTicketEditPauseErrorModalProps {
	open: boolean;
	onRetry: () => void;
}

export const DTicketEditPauseErrorModal = ({
	open,
	onRetry,
}: IDTicketEditPauseErrorModalProps) => {
	const { t } = useTranslation('dticketSubscriptionEditPause');

	return (
		<MplModal
			open={open}
			testId="DTicketSubscriptionEditPause-ErrorModal"
			icon={<ErrorAnim />}
			title={t('error_modal.title')}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onRetry}
					testId="dticket-editPauseErrorModal-retry-button"
				>
					{t('error_modal.button')}
				</MplButton>
			}
		/>
	);
};
